import { SectionConfigBuilder } from '../ThemeConfigBuilder';
import { body, headline, overline } from '../fields/fields';

export default new SectionConfigBuilder()
  .setContext('picker', {
    label: 'Sermon Content',
    description: 'Sermon content display',
    icon: 'Sermon',
  })
  .setContext('editor', {
    label: 'Sermon Content Section',
    description: '',
    icon: 'Sermon',
  })
  .addLayout('layout1', (layout) => {
    layout
      .setDescription('Sermon Media Only')
      .setIcon('SermonLayout6')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setActions(0);
      })
      .addBlock((block) => {
        block.setText([]);
        block.setMedia(0);
        block.setActions(0);
      });
  })
  .build();
